module.exports = new __parcel__URL__("61906_h.2650d3ed.jpg").toString();